/* jshint esversion: 8 */
/* jshint node: true */

import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import WarningIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Header from "./components/Header/Header";
import { BrowserRouter } from "react-router-dom";
import MainContentArea from "./components/MainContentArea/MainContentArea";
import DropDownNavMenu from "./components/DropDownNavMenu/DropDownNavMenu";
import Backdrop from "./components/Backdrop/Backdrop";
import maintIcon from "./assets/images/maintenance-icon.png";
import maintIconWebp from "./assets/images/WEBP/maintenance-icon.webp";
import WebpElement from "components/WebpElement/WebpElement";
import { initDaa } from "stateMgmt/daaSlice";
import { useDispatch } from "react-redux";
import logger from "services/LoggingService";
import * as common from "./common";

import "./App.scss";
import "./Maint.scss";

const alertClasses =
  "text-center fixed-bottom user-alert-show maintenance-banner";

function App() {
  const dispatch = useDispatch();

  const [dropDownNavMenuOpen, setDropDownNavMenuOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const [maintenanceInfo, setMaintenanceInfo] = useState({
    offline: false,
    showSpotlightMaintNotification: false,
    maintenanceMessage1: "",
    maintenanceMessage2: "",
    spotlightMaintenanceNotification: "",
  });

  useEffect(() => {
    logger.debug(`RUNNING ENV ${process.env.REACT_APP_ENV}`);
    logger.debug(`Logging level: ${logger.loggingLevel()}`);

    const maintPath = common.getS3Url() + "maint_message.json";
    const bypass = localStorage.getItem("BypassMaint");

    if (bypass !== "true") {
      // GET MAINT MESSAGE
      fetch(maintPath, {
        method: "GET",
        cache: "no-cache",
      })
        .then((response) => response.json())
        .then((data) => {
          if (
            maintenanceInfo.offline !== data.Spotlight.offline ||
            maintenanceInfo.showSpotlightMaintNotification !==
              data.Spotlight.showMaintenanceNotification
          ) {
            setMaintenanceInfo({
              offline: data.Spotlight.offline,
              showSpotlightMaintNotification:
                data.Spotlight.showMaintenanceNotification,
              maintenanceMessage1: data.Spotlight.offLineMessage,
              maintenanceMessage2: data.Spotlight.maintenanceNotification,
              spotlightMaintenanceNotification:
                data.Spotlight.maintenanceNotification,
            });
          }
        })
        .catch(() => {
          logger.debug(
            "Maint File is missing or connection is bad. Defaulting to normal login.",
          );
        });
    }

    dispatch(initDaa());
  }, []);

  const backdropClickHandler = () => {
    setDropDownNavMenuOpen(false);
  };

  const dropDownMenuToggleClickHandler = () => {
    setDropDownNavMenuOpen(!dropDownNavMenuOpen);
  };

  const renderNormal = () => {
    let backdrop;

    if (dropDownNavMenuOpen) {
      backdrop = <Backdrop click={() => backdropClickHandler()} />;
    }

    return (
      <BrowserRouter>
        <div>
          <Header dropDownMenuClickHandler={dropDownMenuToggleClickHandler} />
          <DropDownNavMenu
            show={dropDownNavMenuOpen}
            dropDownMenuClickHandler={dropDownMenuToggleClickHandler}
          />
          {backdrop}
          <MainContentArea />
          {maintenanceInfo.showSpotlightMaintNotification ? (
            <div>
              <Collapse in={open}>
                <Alert
                  icon={<WarningIcon fontSize="inherit" />}
                  sx={{ color: "#000000" }}
                  variant="filled"
                  severity="warning"
                  className={alertClasses}
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <CloseIcon sx={{ fontSize: "24px" }} />
                    </IconButton>
                  }
                >
                  Alert {maintenanceInfo.spotlightMaintenanceNotification}
                </Alert>
              </Collapse>
            </div>
          ) : (
            <div> </div>
          )}
        </div>
      </BrowserRouter>
    );
  };

  const renderOffline = (maintenanceMessage1, maintenanceMessage2) => {
    return (
      <div className="error-page-wrapper">
        <div className="content-container in">
          <div style={{ width: "100%", textAlign: "center", margin: "auto" }}>
            <h1>Maintenance</h1>
          </div>
          <br />
          <div className="maintenance-img">
            <WebpElement
              className="maintenance-img"
              src={maintIcon}
              webp={maintIconWebp}
              alt="Maint"
              testId="MaintImg"
            />
          </div>
          <br />
          <div className="maintenance-banner">{maintenanceMessage1}</div>
          <hr />
          {/* <div className="clearfix"></div> */}
          <div className="maintenance-text">{maintenanceMessage2}</div>
        </div>
      </div>
    );
  };

  return maintenanceInfo.offline
    ? renderOffline(
        maintenanceInfo.maintenanceMessage1,
        maintenanceInfo.maintenanceMessage2,
      )
    : renderNormal();
}

export default App;
